/* ducks-n-stuff — collection tabs =========================================
   Standard WAI-ARIA tab pattern: click to switch, arrow keys to move between
   tabs, Home/End to jump to the ends.
   ========================================================================= */

class DnsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, i));
    });
  }

  onKeydown(event, i) {
    const last = this.tabs.length - 1;
    let next = null;

    switch (event.key) {
      case 'ArrowRight':
        next = i === last ? 0 : i + 1;
        break;
      case 'ArrowLeft':
        next = i === 0 ? last : i - 1;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = last;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
      if (this.panels[i]) this.panels[i].hidden = !on;
    });
    // keep the chosen tab in view on narrow screens
    this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
}

if (!customElements.get('dns-tabs')) customElements.define('dns-tabs', DnsTabs);
